import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets viewport scroll to top on every route change.
 * Skips reset when a hash (#anchor) is present in the URL so in-page anchors still work.
 * Uses "instant" behavior to avoid perceived jank on navigation.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
